import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiError } from "types/api";

interface EntityState<T> {
  items: T[];
  currentItem: T | null;
  loading: boolean;
  error: ApiError | null;
}

const createEntitySlice = <T>(name: string, service: any) => {
  const initialState: EntityState<T> = {
    items: [],
    currentItem: null,
    loading: false,
    error: null,
  };

  const fetchAll = createAsyncThunk(
    `${name}/fetchAll`,
    async (filters: Record<string, string>, { rejectWithValue }) => {
      try {
        const response = await service.fetchAll(filters);
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error);
      }
    }
  );

  const fetchAllKeys = createAsyncThunk(
    `${name}/fetchAllKeys`,
    async (filters: Record<string, string>, { rejectWithValue }) => {
      try {
        const response = await service.fetchAllKeys(filters);
        console.log('puxou')
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error);
      }
    }
  );

  const fetchById = createAsyncThunk(
    `${name}/fetchById`,
    async (id: string, { rejectWithValue }) => {
      try {
        const response = await service.fetchById(id);
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error);
      }
    }
  );

  const createEntity = createAsyncThunk(
    `${name}/create`,
    async (data: Partial<T>, { rejectWithValue }) => {
      try {
        return await service.create(data);
      } catch (error: any) {
        return rejectWithValue(error);
      }
    }
  );

  const updateEntity = createAsyncThunk(
    `${name}/update`,
    async (
      { id, data }: { id: string; data: Partial<T> },
      { rejectWithValue }
    ) => {
      try {
        return await service.update(id, data);
      } catch (error: any) {
        return rejectWithValue(error);
      }
    }
  );

  const deleteEntity = createAsyncThunk(
    `${name}/delete`,
    async (id: string, { rejectWithValue }) => {
      try {
        return await service.delete(id);
      } catch (error: any) {
        return rejectWithValue(error);
      }
    }
  );

  const entitySlice = createSlice({
    name,
    initialState,
    reducers: {
      setCurrentItem: (state, action) => {
        state.currentItem = action.payload;
      },
      clearCurrentItem: (state) => {
        state.currentItem = null;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchAll.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchAll.fulfilled, (state, action) => {
          state.loading = false;
          state.items = action.payload;
        })
        .addCase(fetchAll.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error as ApiError;
        })
        .addCase(fetchAllKeys.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchAllKeys.fulfilled, (state, action) => {
          state.loading = false;
          console.log('added keys',action.payload)
          state.items = action.payload;
        })
        .addCase(fetchAllKeys.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error as ApiError;
        })
        .addCase(fetchById.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchById.fulfilled, (state, action) => {
          state.loading = false;
          state.currentItem = action.payload;
        })
        .addCase(fetchById.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error as ApiError;
        })
        .addCase(createEntity.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(createEntity.fulfilled, (state, action) => {
          state.loading = false;
          if (action.payload) {
            try{

            state.items.push(action.payload);
            }
            catch(e){
            state.items.data.push(action.payload);
            }
          }
        })
        .addCase(createEntity.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error as ApiError;
        })
        .addCase(updateEntity.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(updateEntity.fulfilled, (state, action) => {
          state.loading = false;
          if (action.payload) {
            try{
            const index = state.items?.findIndex(
              (item) => (item as any)._id === (action.payload as any)._id
            );
            if (index !== -1) {
              state.items[index] = action.payload;
            }
          }
          catch(e){
            const index = state.items?.data?.findIndex(
              (item) => (item as any)._id === (action.payload as any)._id
            );
            if (index !== -1) {
              state.items.data[index] = action.payload;
            }
          }
          }
        })
        .addCase(updateEntity.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error as ApiError;
        })
        .addCase(deleteEntity.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(deleteEntity.fulfilled, (state, action) => {
          state.loading = false;
          try{
          state.items = state.items.filter((item) => (item as any)._id !== action.payload);
          }
          catch(e){
          state.items.data = state.items.data.filter((item) => (item as any)._id !== action.payload);

          }
        })
        .addCase(deleteEntity.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error as ApiError;
        });
    },
  });

  return {
    reducer: entitySlice.reducer,
    actions: entitySlice.actions,
    fetchAll,
    fetchAllKeys,
    fetchById,
    createEntity,
    updateEntity,
    deleteEntity,
  };
};

export default createEntitySlice;
